// client/src/api/core/parseJson.ts
//
// Utility condivisa per il parsing sicuro di Response JSON.
// Usata da apiFetch.ts e da qualsiasi domain file che legge raw Response.

/**
 * Legge la Response come testo e tenta il parsing JSON.
 * Ritorna {} se il body è vuoto o non è JSON valido.
 */
export async function parseJsonSafe(
  res: Response
): Promise<Record<string, unknown>> {
  const text = await res.text();
  try {
    return text ? (JSON.parse(text) as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}
